import * as TFF from '@tff/types/tff';

export const feesSumPerPax = (feesAndTaxes: TFF.FeeAndTax[] | undefined): number => {
  return feesAndTaxes?.reduce((sum, fee) => sum + (fee.Amount || 0), 0) ?? 0;
};

export const calculatePaxFees = (fares: Record<string, TFF.Fare> | undefined): number => {
  const paxRegex = /^PAX\d+$/;
  return Object.keys(fares || {})
    .filter(key => paxRegex.test(key))
    .reduce((total, key) => {
      const feesSum = feesSumPerPax(fares?.[key]?.FeesAndTaxes);
      return total + feesSum;
    }, 0);
};

export const calculateOscPrice = (orderDetails?: TFF.OrderDetails): number => {
  return orderDetails?.AdditionalParams?.operationServiceCharge ?? 0;
};

export const calculateTotalMarkupPrice = (retrieveDb?: TFF.BookedRetrieve): number => {
  return retrieveDb?.pricePerPax?.reduce((sum, item) => sum + item.markup, 0) ?? 0;
};

export const calculateTotalPrice = (
  orderSummary: TFF.OrderSummary,
  serviceFeeTotalAmount: number,
  retrieveDb: TFF.BookedRetrieve | undefined,
  isTTSBooking: boolean,
  isNdcFlightOnlyBooking: boolean,
  orderDetails?: TFF.OrderDetails,
): number => {
  let totalPrice = (orderSummary?.TotalFarePrice ?? 0) + (orderSummary?.TotalAncillaryPrice ?? 0);

  if (isNdcFlightOnlyBooking) {
    const rebookFee = feesSumPerPax(orderDetails?.Fares?.['ALL']?.FeesAndTaxes);
    const passengersInitialFees = calculatePaxFees(orderDetails?.Fares);

    totalPrice += rebookFee + passengersInitialFees;
  } else {
    totalPrice += serviceFeeTotalAmount;

    if (isTTSBooking) {
      const totalMarkup = calculateTotalMarkupPrice(retrieveDb);
      const oscPrice = calculateOscPrice(orderDetails);

      totalPrice += totalMarkup + oscPrice;
    }
  }

  return totalPrice;
};
